import React from 'react';
import { Box, Typography } from '@mui/material';

const Footer = () => {
  return (
    <Box className="footer">
      <Typography variant="body2">
        &copy; 2025 SSN M3. All rights reserved.
      </Typography>
    </Box>
  );
};

export default Footer;
